<template>
  <div class="menu" :class="{'active' : showMenu}">
    <router-link to="/" tag="div" @click.native="onClose" class="menu__close menu__close--home"><i class="mdi mdi-home"></i></router-link>
    <div class="menu__close" @click.prevent="onClose">Close <i class="mdi mdi-window-close"></i></div>
    <nav class="menu__list">
      <router-link to="/services" @click.native="onClose">Разработка</router-link>
      <router-link to="/equipment" @click.native="onClose">Оборудование</router-link>
      <router-link to="/solutions" @click.native="onClose">Готовые решения</router-link>
      <router-link to="/portfolio" @click.native="onClose">Портфолио</router-link>
      <router-link to="/contact" @click.native="onClose">Связаться с нами</router-link>
    </nav>
    <nav class="menu__footer">
      <h4 class="menu__subtitle">Другие проекты:</h4>
      <a href="https://video.giveandgo.ru" target="_blank">Видеостудия</a>
      <!-- <a href="https://school.giveandgo.ru" target="_blank">IT-школа</a> -->
    </nav>
  </div>
</template>
<script>
const name = "Menu"

const computed = {
  showMenu() {
    return this.$store.state.template.showMenu
  }
}

function onClose() {
  this.$store.commit('template/setMenuState', false)
}

export default {
  name,
  computed,
  methods: {
    onClose
  }
}

</script>
